import React from 'react';

function AddBottomIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M4.333 1.667c-.729.132-1.266.366-1.69.78C1.667 3.4 1.667 4.933 1.667 8c0 3.067 0 4.6.976 5.553.424.414.961.648 1.69.78M11.667 14.333c.729-.132 1.266-.366 1.69-.78.976-.953.976-2.486.976-5.553 0-3.067 0-4.6-.976-5.553-.424-.414-.961-.648-1.69-.78M6.667 1.67c.39-.003.859-.003 1.316-.003.457 0 .967 0 1.358.003M6.667 14.33c.39.003.859.003 1.316.003.457 0 .967 0 1.358-.003M8 1.667v1m0 10.666v1M6 8l2 2m2-2l-2 2m0-4v4'
			></path>
		</svg>
	);
}

export default AddBottomIcon;
